import React from "react";

export function AnalysisQuizPointRate() {
  return (
    <svg
      width="70"
      height="8"
      viewBox="0 0 70 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line y1="4" x2="70" y2="4" stroke="#FEDF3F" />
      <circle cx="34.5" cy="4" r="3.5" fill="#FBB02D" />
    </svg>
  );
}

export function AnalysisQuizYourPoint() {
  return (
    <svg
      width="70"
      height="7"
      viewBox="0 0 70 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line y1="3.5" x2="70" y2="3.5" stroke="#38B000" strokeDasharray="7 7" />
      <circle cx="34.5" cy="3.5" r="3.5" fill="#38B000" />
    </svg>
  );
}
